export default __webpack_public_path__ + "static/media/icon_login.83689fb0.png";